import {focusElement, hookToAttributeSelector} from '@wix/panda-js-utils'
import {BI_ORIGINS, getDynamicThankYouMessage, getEventTitle, isDateTbd} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import {isHeadless} from '../../../../../../commons/selectors/environment'
import {useAppActions, useAppSelector} from '../../../hooks/runtime'
import {isMember} from '../../../selectors/current-member-details'
import {getEvent, getFormMessages} from '../../../selectors/event'
import {showGroupCard} from '../../../selectors/groups'
import {getFormattedRsvpFullNameAndEmail} from '../../../selectors/member-rsvp'
import {getThankYouMessageState} from '../../../selectors/navigation'
import c from '../../classnames.scss'
import {BackToSiteLink} from '../../common/back-to-site-link'
import {GroupCard} from '../../group-card'
import {SocialShare} from '../../social-share'
import {Container} from '../common/container'
import {Subtitle} from '../common/subtitle'
import {SuccessActions} from '../common/success-actions'
import {Title} from '../common/title'
import s from './thank-you-messages.scss'

export const ThankYouMessages = () => {
  const {t} = useTranslation()
  const {thankYouPageLoaded} = useAppActions()

  const headless = useAppSelector(isHeadless)
  const event = useAppSelector(getEvent)
  const {guestEmail, guestName} = useAppSelector(getFormattedRsvpFullNameAndEmail)
  const thankYouMessageState = useAppSelector(getThankYouMessageState)
  const member = useAppSelector(isMember)
  const showGroup = useAppSelector(showGroupCard)

  const {
    confirmation: {title: confirmationTitle, message, addToCalendarActionLabel, shareActionLabel},
  } = getFormMessages(event, thankYouMessageState) as wix.events.form.RsvpFormMessages.Positive
  const {title, subtitle} = getDynamicThankYouMessage(
    {title: confirmationTitle, subtitle: message},
    {name: guestName, email: guestEmail, eventName: getEventTitle(event)},
  )
  const hideAddToCalendar =
    isDateTbd(event) || thankYouMessageState === 'waiting' || thankYouMessageState === 'waitlist'

  useEffect(() => {
    thankYouPageLoaded()
    focusElement({selector: hookToAttributeSelector(DH.THANK_YOU_MESSAGE_TITLE)})
  }, [])

  return (
    <Container dataHook={DH.THANK_YOU_MESSAGE}>
      <div className={classNames(s.container, c.thankYouMessages, c.formLabelsFont, c.formTitleColor)}>
        <Title dataHook={DH.THANK_YOU_MESSAGE_TITLE} text={title} />
        {!!subtitle && (
          <Subtitle
            dataHook={DH.THANK_YOU_MESSAGE_NOTIFICATION}
            lines={[
              subtitle,
              member && !headless
                ? t('members.rsvpThankYouMessage', {
                    eventsMembersPageTitle: t('eventsMembersPageName'),
                    interpolation: {escapeValue: false},
                  })
                : null,
            ]}
          />
        )}
        <BackToSiteLink className={s.backToSite} />
        <SuccessActions
          className={s.successActions}
          downloadTicketsVisible={false}
          addToCalendarVisible={!hideAddToCalendar && !!addToCalendarActionLabel}
          calendarButtonText={addToCalendarActionLabel}
        />
        {showGroup && <GroupCard className={s.group} />}
        {!!shareActionLabel && !headless && (
          <div className={s.share}>
            <div data-hook={DH.SOCIAL_SHARE_TITLE}>{shareActionLabel}</div>
            <div className={s.shareButtons}>
              <SocialShare page={BI_ORIGINS.THANK_YOU_PAGE} />
            </div>
          </div>
        )}
      </div>
    </Container>
  )
}
